import { render, staticRenderFns } from "./tenant-users.vue?vue&type=template&id=afe07696&"
import script from "./tenant-users.vue?vue&type=script&lang=js&"
export * from "./tenant-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports